import light from './modes/light'
import dark from './modes/dark'

export default {
    light,
    dark
}
